var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/File/report_service") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/File/report_service",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61,64 L19,64 L19,16 C19,14.896 19.896,14 21,14 L61,14 L61,64 Z",
    id: "Fill-1",
    fill: "#135396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#FFFFFF",
    points: "25 61 58 61 58 18 25 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,25 L44,23 L53,23 L53,25 L44,25 Z M44,30 L44,28 L53,28 L53,30 L44,30 Z",
    id: "Combined-Shape",
    fill: "#9A9CA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,66 L21,66 C19.896,66 19,65.116 19,64 L19,16 L48,16 L48,29 L55,36 L55,66 Z",
    id: "Fill-7",
    fill: "#00ABE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.238,46.025 C42.262,47.002 40.679,47.002 39.703,46.025 C38.726,45.049 38.726,43.466 39.703,42.49 L41.804,40.388 C41.148,40.141 40.44,40 39.697,40 C36.384,40 33.697,42.686 33.697,46 C33.697,46.742 33.839,47.451 34.085,48.107 L29.032,53.16 C28.056,54.136 28.056,55.719 29.032,56.695 C30.009,57.672 31.592,57.672 32.568,56.695 L37.635,51.628 C38.279,51.864 38.971,52 39.697,52 C43.01,52 45.697,49.313 45.697,46 C45.697,45.274 45.562,44.582 45.325,43.938 L43.238,46.025 Z",
    id: "Fill-21",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportService);
export default __webpack_public_path__ + "static/media/report_service.82e5f6fa8bdbec9597f1b0e524c27e46.svg";
export { ForwardRef as ReactComponent };